import {createBlacklistFilter} from 'redux-persist-transform-filter';

export const blacklistFilterAjaxCallsNumber = createBlacklistFilter(
    'layout',
    [ 'ajaxCallsInProgress']
);

export const blacklistFilterGridSettings1 = createBlacklistFilter(
    'grid',
    ['pagesGrid.loading']
);

export const blacklistFilterGridSettings2 = createBlacklistFilter(
    'grid',
    ['usersGrid.loading']
);

export const blacklistFilterGridSettings3 = createBlacklistFilter(
    'grid',
    ['blocksGrid.loading']
);



// WEBPACK FOOTER //
// ./src/components/blacklist/persist_blacklist.js